;(function($){
    $(function() { 
      var setAfterpayProxy = function($root) {
          var proxy = function(){};
            if (window.Afterpay && Afterpay.generateInstalmentHTML && 
                    (typeof Afterpay.generateInstalmentHTML === "function" )
                    && (typeof Afterpay.extractPriceFromHTML === "function" )) {
               proxy = function(price) {
                   var pies = Afterpay.generateInstalmentHTML(Afterpay.extractPriceFromHTML(price));
                   var $pies = $root.find('.afterpay-paragraph .afterpay-instalments');
                   if($pies.length > 0) {
                       $pies.html(pies);
                   }                                        
               };
               console.log('Afterpay is synced up');
            } 
            return proxy;
      } 
        
        
      var setPrice = function() {
          var $root = $('#product-builder');
          var updateAfterpay = setAfterpayProxy($root);
          var updatePrice = function() {
              var currentPrice = $root.find('.cpb-product-price').text();
              $root.find('.cpb-pdp-top .product__price span').text(currentPrice );
              updateAfterpay(currentPrice);
          };
          function mutate(mutations) {
              mutations.forEach(function(mutation) {  
                  if (mutation.type == 'characterData') {
                      updatePrice();
                  }
              });
          }

          var target = document.querySelector('.cpb-product-price'); 
          var observer = new MutationObserver( mutate );
          var config = { characterData: true, attributes: false, childList: true, subtree: true };
          observer.observe(target, config);  
          updatePrice();
      }; 
      
      var customJS = function() {
        console.log('CPB here');
        var $top = $('#product-builder-additions .cpb-pdp-top').detach();
        var $bottom = $('#product-builder-additions .cpb-pdp-bottom').detach();        
        
        $('#product-builder .cpb-panels-container').prepend($top);
        $('#product-builder .cpb-panels-container').append($bottom);
        setPrice();
      };
      
      var cpbLoaded = function() {
            if ($('#product-builder .cpb-product-actions').length > 0) {
                customJS();
                
            } else {
              window.requestAnimationFrame(cpbLoaded);
            }   
        };
        cpbLoaded(); 
        
    });    
})(jQuery); 